export const getOtaData = (data) => {
    const demand = {};
    const dataGroupByHotelId = data.reduce((accu, currentValue) => {
        let object = accu.filter((e) => e.hotelId === currentValue.hotelId)[0];

        if (!object) {
            object = {
                hotelId: currentValue.hotelId,
                hotelName: currentValue.hotelName,
            };
            accu.push(object);
        }

        object[currentValue.stayDate] = { ...currentValue };
        demand[currentValue.stayDate] = currentValue.demand;
        return accu;
    }, []);
    return { data: dataGroupByHotelId, demand };
};

export const getOTAMessage = (message) => {
    switch (message) {
        case 'rates.soldout':
            return 'Sold Out';
        case 'rates.restrictionlos2':
            return 'LOS2';
        case 'rates.restrictionlos3':
            return 'LOS3';
        case 'rates.no_person.2':
            return 'Double Occ.';
        case 'general.missing':
        default:
            return 'N/A';
    }
};
